import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Input } from "../../primitives/Input";
import { Button } from "../../primitives/Button";
import { useAuth } from "../../provider";
import { AuthLayout } from "./AuthLayout";
export function ForgotPasswordEmail() {
    const navigate = useNavigate();
    const { authClient } = useAuth();
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleSendResetLink = async () => {
        setIsLoading(true);
        setError(null);
        try {
            await authClient.forgotPassword(email);
            navigate("/auth/forgot-password/check-email", { state: { email } });
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Failed to send reset link");
        }
        finally {
            setIsLoading(false);
        }
    };
    return (_jsxs(AuthLayout, { children: [_jsx("h1", { className: "text-duvi-text-primary mb-2", style: {
                    fontSize: "var(--text-xl)",
                    fontWeight: "var(--font-weight-semibold)",
                    lineHeight: "var(--line-height-heading)",
                }, children: "Reset your password" }), _jsx("p", { className: "text-duvi-text-secondary mb-6", style: {
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-height-body)",
                }, children: "Enter your email and we'll send a reset link." }), _jsxs("div", { className: "mb-6", children: [_jsx("label", { className: "block text-duvi-text-primary mb-2", style: { fontSize: "var(--text-sm)" }, children: "Email" }), _jsx(Input, { type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "Email address", "data-testid": "forgot-password-email" })] }), error && (_jsx("div", { className: "mb-4 text-duvi-destructive", style: { fontSize: "var(--text-sm)" }, children: error })), _jsx(Button, { variant: "primary", className: "w-full mb-4", onClick: handleSendResetLink, disabled: isLoading, "data-testid": "forgot-password-submit", children: isLoading ? "Sending..." : "Send reset link" }), _jsx("div", { className: "text-center", children: _jsx("button", { onClick: () => navigate("/auth/password"), className: "text-duvi-text-secondary hover:text-duvi-text-primary transition-colors", style: { fontSize: "var(--text-xs)" }, children: "Back to login" }) })] }));
}
//# sourceMappingURL=ForgotPasswordEmail.js.map